module.exports = __webpack_public_path__ + "static/media/pricing3.2770253c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pricing3.png
// module id = 1388
// module chunks = 0